import React from 'react';
import { type ColumnDef, createColumnHelper } from '@tanstack/react-table';
import { type TFunction } from 'i18next';

import { type MidotRoleDTO } from '@/api/generated';
import BaseCell from '@/components/DataGrid/BaseCell';
import TextCell from '@/components/DataGrid/TextCell';
import UserDisplay from '@/containers/Organizations/UserDisplay';

const columnHelper = createColumnHelper<MidotRoleDTO>();

export const roleColumns = (t: TFunction) =>
  [
    columnHelper.accessor('name', {
      header: () => t('roles.columns.name'),
      cell: ({ getValue }) => <TextCell>{getValue()!}</TextCell>,
      size: 300
    }),
    columnHelper.accessor('usersSummary', {
      header: () => t('roles.columns.users'),
      cell: ({ getValue, row }) => (
        <BaseCell>
          <UserDisplay value={getValue()!} totalCount={row.original.usersCount} />
        </BaseCell>
      ),
      size: 700
    })
  ] as ColumnDef<MidotRoleDTO>[];
